import React, { Component } from "react";
import { connect } from "react-redux";
import withAuth from "../../../components/Services/WithAuth";
import withRouter from "../../../withRouter";
import {
  Col,
  FormGroup,
  Row,
  Button,
  Card,
  CardBody
} from "reactstrap";
import { setPageView } from "../../../components/GoogleAnalytics";
import FileUpload from "./FileUpload";
import { Preloading } from "../../../components/UI/Preloader/action";
import { toast } from "react-toastify";

import {
  bulkUploadRequest,
  getCorporatesRequest,
  downloadTemplateRequest
} from './actions';

class CreateBulkEndUserUpload extends Component {
  state = {
    fileUploadKey: Date.now(), 
    selectedCorporate: "",
    selectedFile: null,
    previewData: null,
    uploadProgress: 0,
    error: "",
    rowCount: 2, 
    corporateSearch: "", 
    filteredCorporates: [], 
    showDropdown: false, 
  };

  componentDidMount() {
    setPageView("/Admin/corporate/bulkUserUpload", document.location.href);
    this.props.getCorporatesRequest();
  }

  componentDidUpdate(prevProps) {
  
  if (
    this.props.successMessage &&
    prevProps.successMessage !== this.props.successMessage
  ) {
    this.props.Preloading(false);
    toast.success(this.props.successMessage);
    this.setState({
      selectedCorporate: "",   
      selectedFile: null,
      uploadProgress: 0,
      previewData: [],
      error: "",
      fileUploadKey: Date.now(),                
    });
  }

  if (
    this.props.errorMessage &&
    prevProps.errorMessage !== this.props.errorMessage
  ) {
    this.props.Preloading(false);
    toast.error(this.props.errorMessage);
    this.setState({
      selectedCorporate: "",   
      selectedFile: null,
      uploadProgress: 0,
      previewData: [],
      error: "",
      fileUploadKey: Date.now(),                
    });
  }

  if (
    this.props.templateError &&
    prevProps.templateError !== this.props.templateError
  ) {
    this.props.Preloading(false);
    toast.error(this.props.templateError);
  }
}

  handleCorporateSearch = (e) => {
  const search = e.target.value;
  const filtered = this.props.corporates.filter(
    (c) =>
      c.name.toLowerCase().includes(search.toLowerCase()) ||
      c.id.toString().includes(search)
  );
  this.setState({
    corporateSearch: search,
    filteredCorporates: filtered,
    showDropdown: true,
  });
  };

  
  handleDownloadTemplate = () => {
    const { selectedCorporate, rowCount } = this.state;

    if (!selectedCorporate) {
      toast.warning("Please select a corporate before downloading the template.");
      return;
    }

    this.props.Preloading(true);
    this.props.downloadTemplateRequest(selectedCorporate,rowCount);
  };

  
  handleUpload = () => {
    const { selectedCorporate, selectedFile } = this.state;

    if (!selectedCorporate || !selectedFile) {
      toast.warning("Please select a corporate and a file to upload.");
      return;
    }

    this.props.Preloading(true);

    this.props.bulkUploadRequest(
      selectedCorporate,
      selectedFile,
      (progressEvent) => {
        const percent = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        this.setState({ uploadProgress: percent });
      }
    );
  };

  render() {
    const { corporates } = this.props;
    const { uploadProgress } = this.state;

    return (
      <Col>
        <Card className="shadow-sm border-0">
          <CardBody>
            {/* Header */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <h4 className="mb-4 font-weight-bold">
                Corporates Bulk End User Upload
              </h4>

              <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                {/* Row Count Input */}
                <div>
                  <label>
                    Enter User Count:
                    <input
                      type="number"
                      min="1"
                      max="1000"
                      style={{ width: "80px", marginLeft: "5px" }}
                      value={this.state.rowCount || 2} 
                      onChange={(e) =>
                        this.setState({ rowCount: Number(e.target.value) })
                      }
                    />
                  </label>
                </div>

                {/* Download Template Button */}
                <Button
                  color="primary"
                  onClick={this.handleDownloadTemplate}
                  title="Download the Excel template for selected corporate"
                >
                  Download Template
                </Button>
              </div>
            </div>

            {/* Corporate Dropdown */}
            <Row>
              <Col lg="12" md="6" className="py-3">
                <FormGroup className="w-75 position-relative">
                  <label>
                    Corporate&nbsp;<span className="text-danger">*</span>
                  </label>

                  <input
                    type="text"
                    className="form-control"
                    placeholder="Type to search..."
                    value={this.state.corporateSearch}
                    onChange={this.handleCorporateSearch}
                    onFocus={() =>
                      this.setState({
                        filteredCorporates: this.props.corporates,
                        showDropdown: true,
                      })
                    }
                    disabled={this.props.corporates.length === 0}
                  />

                  {this.state.showDropdown && this.state.filteredCorporates.length > 0 && (
                    <ul
                      className="dropdown-menu show w-100"
                      style={{ maxHeight: "200px", overflowY: "auto", position: "absolute" }}
                    >
                      {this.state.filteredCorporates.map((c) => (
                        <li
                          key={c.id}
                          className="dropdown-item"
                          style={{ cursor: "pointer" }}
                          onMouseDown={() =>
                            this.setState({
                              selectedCorporate: c.id,
                              corporateSearch: c.name,
                              showDropdown: false,
                            })
                          }
                        >
                          {c.name} ({c.id})
                        </li>
                      ))}
                    </ul>
                  )}
                </FormGroup>
              </Col>
            </Row>

            {/* File Upload */}
            <FileUpload
              key={this.state.fileUploadKey}
              onFileSelect={(file) => this.setState({ selectedFile: file })}
              uploadProgress={uploadProgress}
              previewData={this.state.previewData}
              setPreviewData={(data) => this.setState({ previewData: data })}
              setError={(err) => this.setState({ error: err })}
              conditionalColumnConfig={{
                triggerColumn: "Report Access*",
                triggerValue: "Specific",
                dependentColumn: "Access Corporate Reports*",
              }}
            />

            {/* Upload Button */}
            <Row className="mt-4">
              <Col md={4}>
                <Button
                  color="success"
                  block
                  onClick={this.handleUpload}
                  disabled={uploadProgress > 0 && uploadProgress < 100}
                >
                  {uploadProgress > 0
                    ? `Uploading ${uploadProgress}%`
                    : "Upload & Process"}
                </Button>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Col>
    );
  }
}
const mapStateToProps = (state) => ({
  corporates: state.corporateBulkEndUserData.corporates,
  successMessage: state.corporateBulkEndUserData.successMessage,
  errorMessage: state.corporateBulkEndUserData.errorMessage,
  templateError: state.corporateBulkEndUserData.templateError,
});

const mapDispatchToProps = (dispatch) => ({
  bulkUploadRequest: (id, file, progress) =>
    dispatch(bulkUploadRequest(id, file, progress)),

  getCorporatesRequest: () =>
    dispatch(getCorporatesRequest()),

  downloadTemplateRequest: (corporateId, rowCount) =>
    dispatch(downloadTemplateRequest(corporateId, rowCount)),

  Preloading: (status) =>
    dispatch(Preloading(status)),
});

export default withRouter(
  withAuth(
    connect(mapStateToProps, mapDispatchToProps)(
      CreateBulkEndUserUpload
    )
  )
);